import { platformClient } from './platform.client';
import { SchoolSetupRequest } from '../types';
import { StatusResponse } from '../../../types/api';

export interface TeacherProfileRequest {
  bio?: string;
  subjects?: string[];
}

export interface StudentProfileRequest {
  bio?: string;
  interests?: string[];
}

export interface LinkChildRequest {
  link_code: string;
}

export const schoolSetup = async (data: SchoolSetupRequest): Promise<StatusResponse & { classes: any[] }> => {
  const response = await platformClient.post<StatusResponse & { classes: any[] }>(
    '/onboarding/school-setup',
    data
  );
  return response.data;
};

export const completeTeacherProfile = async (
  data: TeacherProfileRequest
): Promise<StatusResponse & TeacherProfileRequest> => {
  const response = await platformClient.post<StatusResponse & TeacherProfileRequest>(
    '/onboarding/teacher-profile',
    data
  );
  return response.data;
};

export const completeStudentProfile = async (
  data: StudentProfileRequest
): Promise<StatusResponse & StudentProfileRequest> => {
  const response = await platformClient.post<StatusResponse & StudentProfileRequest>(
    '/onboarding/student-profile',
    data
  );
  return response.data;
};

export const linkChild = async (data: LinkChildRequest): Promise<StatusResponse & { student: any }> => {
  const response = await platformClient.post<StatusResponse & { student: any }>(
    '/onboarding/parent/link-child',
    data
  );
  return response.data;
};

